import { Component, inject } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { AddButtonComponent } from "@components/add-button/add-button.component";
import { ToggleItemTextVisibilityButtonComponent } from "@components/toggle-item-text-visibility-button/toggle-item-text-visibility-button.component";
import { ToggleLockButtonComponent } from "@components/toggle-lock-button/toggle-lock-button.component";
import { ToggleVisibilityButtonComponent } from "@components/toggle-visibility-button/toggle-visibility-button.component";
import { FloorplanState } from "@domain/project/floorplan/floorplan-state";
import { FloorplanMenuItemButtonsComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-menu-item-buttons/floorplan-menu-item-buttons.component";
import { FloorplanService } from "@project/floorplanner/floorplan.service";
import { DraggedItemType, FloorplanDragDropService } from "@utils/floorplan-drag-drop.service";

@Component({
  selector: "app-floorplan-reference-measure-menu",
  imports: [
    AddButtonComponent,
    FloorplanMenuItemButtonsComponent,
    ToggleLockButtonComponent,
    ToggleVisibilityButtonComponent,
    UiKitModule,
    ToggleItemTextVisibilityButtonComponent,
  ],
  templateUrl: "./floorplan-reference-measure-menu.component.html",
  styleUrl: "./floorplan-reference-measure-menu.component.scss",
  standalone: true,
})
export class FloorplanReferenceMeasureMenuComponent {
  protected floorplanService = inject(FloorplanService);
  private dragDropService = inject(FloorplanDragDropService);

  protected floorplanState: FloorplanState;

  protected readonly tooltipTextAddMeasurement: string = $localize`:@@floorplan.button.addReferenceMeasure:Referenzmaß hinzufügen`;

  constructor() {
    this.floorplanState = this.floorplanService.selectedFloorplan.floorplanState;
  }

  addReferenceMeasure() {
    this.floorplanService.addReferenceMeasure();
  }

  dragReferenceMeasure() {
    this.dragDropService.setDragged({ type: DraggedItemType.REFERENCE_MEASURE });
  }

  protected updateReferenceMeasureItemTextVisibility(visible: boolean) {
    this.floorplanState.updateReferenceMeasureItemTextVisibility(visible);
  }
}
